"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preventVueObservability = exports.isSourceAdapter = void 0;
var vue_model_1 = require("./vue-model");
// Include English resources by default
require("@cognitoforms/model.js/lib/resource-en");
exports.default = vue_model_1.VueModel;
var source_adapter_1 = require("./source-adapter");
Object.defineProperty(exports, "isSourceAdapter", { enumerable: true, get: function () { return source_adapter_1.isSourceAdapter; } });
var vue_model_observability_1 = require("./vue-model-observability");
Object.defineProperty(exports, "preventVueObservability", { enumerable: true, get: function () { return vue_model_observability_1.preventVueObservability; } });
